// extracted by mini-css-extract-plugin
module.exports =  {"root":"VDwTmLxrXGPqDt4QtK89"};